import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators,FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import {SelectionModel} from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';

import { ControlEscriturasModel} from './ControlEscrituras.model';
//import { MchInformacionEscrituraId } from './ControlEscritura.model';

import { OpcionModel } from '../Global/Opcion.model';
import { ConfirmarEliminacionService } from '../Dialog/ConfirmarEliminacionService';





@Component({
	selector : 'ControlEscrituras',
	templateUrl : './ControlEscrituras.component.html',
	styleUrls  : ['../../../../styles.css']
})


export class ControlEscrituraComponent {
	
	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	public btnConsultar:boolean;
	public activarDescarga:boolean;

	public ocultar: boolean = false;
	public mensaje: string = "";
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public listaNegocios:Array<OpcionModel>;
    public listaPrefijos:Array<OpcionModel>;
    public listaEscrituras:Array<OpcionModel>;

    public escrituras:Array<ControlEscriturasModel>;
    public nescrituras = new Array();

	public form: FormGroup;
	public formErrors: any;
	public cnumcont:OpcionModel ;
    public ciddoc:OpcionModel ;
	public vidEscritura:OpcionModel ;
	public particularidad:OpcionModel ;
	public nombreArchivo:any;
	public direccionURL:any;

	public dataDataBase:EscriturasDatabase;

	public dataSource:ExampleDataSource;

	public permisos:any;
	public displayedColumns = ['nid', 'vdescripcion'];

	public bloquear:boolean = false;

	public ocultarSnackBar: boolean = false;
	public mensajeSnackBar: string = "";

	particularidadesControl = new FormControl();
	cnumcontControl = new FormControl();
    ciddocControl = new FormControl();
    vidEscrituraControl = new FormControl();
    
    cnumcontOptions: Observable<OpcionModel[]>;
	particularidades: Observable<OpcionModel[]>;
    ciddocOptions: Observable<OpcionModel[]>;
    vidEscrituraOptions: Observable<OpcionModel[]>;
    
    options = [];
	safeSrc: SafeResourceUrl;
	

	public contrato:string;
    public prefijo:string;
    public vidEswcritura:string;
	public vdescripcion:string;
	public vparticularidad:string;

	public prefijoTresPuntos:string;
	public contratoTresPuntos:string;
	public escrituraTresPuntos:string;
	public tiposParticularidad:Array<OpcionModel>;

	public controlEscrituraTresPuntos:boolean=false;
    
	public tipoP:string;
	private SeEliminaEscritura: number = 0;

/*	public dataDataBase:NegociosDatabase;
	public dataSource:ExampleDataSource;
	*/
	@ViewChild('filter') filter: ElementRef;
    selection = new SelectionModel<any>(true, []);


	constructor(private formBuilder: FormBuilder, private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router:Router, public dialog: MatDialog, private confirmarEliminacionService:ConfirmarEliminacionService,private sanitizer: DomSanitizer){		

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		
		this.snackBar.dismiss();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.tiposParticularidad = new Array();
		this.listaNegocios = new Array();
        this.listaPrefijos = new Array();
        this.listaEscrituras = new Array();
		//this.permisos = _serviciosGenerales.seguridad.getCrud();
		//console.log('Permisos: ', this.permisos);

		this.cnumcont = new OpcionModel("","");
        this.ciddoc = new OpcionModel("","");
        this.vidEscritura = new OpcionModel("","");
		this.particularidad = new OpcionModel("","")
		this.vparticularidad = "";


		this.form = this.formBuilder.group({
			filtroCnumcont   : [
			{
				value   : this.cnumcont.labelOpcion,
				disabled: this.bloquear
			}],
			filtroCiddoc   : [
			{
				value   : this.ciddoc.labelOpcion,
				disabled: this.bloquear
            }],
            filtroVidEscritura   : [
                {
                    value   : this.vidEscritura.labelOpcion,
                    disabled: this.bloquear
                }]
		});
	
		this.safeSrc =  this.sanitizer.bypassSecurityTrustResourceUrl("http://192.168.2.50:8091/facturacion/documento2.pdf");

	}


	ngOnInit(){
		//console.log('CARGA EL FORMULARIO ........ ');
		//this.cargarTabla();

		

		this._serviciosGenerales.get('listaNegociosInmobiliaria', {ntipoempresa : -1}).subscribe(
			
			result=>{
				for(let x in result)
					this.listaNegocios.push(new OpcionModel(result[x].cnumcont.trim(), result[x].vnombrenegocio.trim()));
				

				this.cnumcontOptions = this.cnumcontControl.valueChanges
				.startWith(null)
				.map(val => val ? this.filtro(val) : this.listaNegocios.slice());

				this._route.params.subscribe(params=>{
					console.log(params);
					if( !!params["cnumcont"]){
						this.tipoP = params["edi"];
						this.contrato = params["cnumcont"];
                        this.prefijo = params["cprefijo"];
                        this.vidEscritura =  params["vidEscritura"];
						this.vdescripcion =  params["vdescripcion"];

						

						for(let x in result)
							if(result[x].cnumcont.trim() == params["cnumcont"].trim())
								this.cnumcont.labelOpcion = result[x].cnumcont.trim()+' - '+result[x].vnombrenegocio.trim();

                            if(!!params["cprefijo"] )                            
                                this.eventoConsulta1(params["cprefijo"]);
                                
                            if(!!params["vidEscritura"] ){           
								console.log(this.vidEscritura,'---///',this.prefijo)                
								this.eventoConsultaEscrituras1(this.vidEscritura,this.prefijo,this.contrato,this.vdescripcion)
								this.controlEscrituraTresPuntos= true;
							}
					}

				});

			},
			error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar la lista de negocios", "X");
			});
			
			this._serviciosGenerales.get('particularidad', {param:0}).subscribe(result =>{
				for(let x of result)
					this.tiposParticularidad.push(new OpcionModel(x.id, x.Particularidad));
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de identificación", "X");
			});	
			
		

		this.listaPrefijos.push(new OpcionModel("", ""));
		
		this.ciddocOptions = this.ciddocControl.valueChanges
		.startWith(null)
		.map(val => val ? this.filtroPrefijo(val) : this.listaPrefijos.slice());
		
        this.listaEscrituras.push(new OpcionModel("", ""));
		this.vidEscrituraOptions = this.vidEscrituraControl.valueChanges
		.startWith(null)
        .map(val => val ? this.filtroEscrituras(val) : this.listaEscrituras.slice());
        
	}

	
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataDataBase.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {

	for (let x of this.dataDataBase.data) {
		if(!this.isAllSelected()){
		x.activarChek = true;
		}else{
		x.activarChek = false;
		}
    }
	  console.log("bouy");
	  console.log(this.isAllSelected());

    this.isAllSelected() ?
	this.selection.clear() :
        this.dataDataBase.data.forEach(row => this.selection.select(row));
  }

  logSelection() {
    this.selection.selected.forEach(s => console.log(s.data.values.name));
  }

	private inicializarLista(cnumcont, ccodcon){
		this.cnumcont.labelOpcion = cnumcont;
	}

	filtro(val: string)//: string[]
	{
		if(val == null){
			val = "";
		}
		let x = this.listaNegocios.filter(option =>(option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1); 
		return x;
	}



	filtroPrefijo(val: string)//: string[]
	{
		if(val == null){
			val = "";
		}
		let x = this.listaPrefijos.filter(option =>(option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1); 		
		return x;
	}

    filtroEscrituras(val: string)//: string[]
	{
		if(val == null){
			val = "";
		}
		let x = this.listaEscrituras.filter(option =>(option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1); 		
		return x;
	}



	eventoConsulta(opcional){
		
		this.cnumcont.idOpcion = this.cnumcont.labelOpcion.substring(0,this.cnumcont.labelOpcion.indexOf('-')).trim();
		this.listaPrefijos = new Array();
		this.activarDescarga= false;
		this.ciddoc = new OpcionModel(" ", " ");
		

		this._serviciosGenerales.get('listaPrefijos', {cnumcont : this.cnumcont.idOpcion, ntipoempresa : -1}).subscribe(
			
			result=>{
				for(let x in result)
					this.listaPrefijos.push(new OpcionModel(result[x].cprefijo.trim(), result[x].cprefijo.trim()));
				
				if(this.listaPrefijos.length == 0){
					this.openSnackBarEspecial("No se encontraron prefijos para el contrato : "+this.cnumcont.idOpcion, "X");
					return;
				}
				else
					this.snackBar.dismiss();


				this.ciddocOptions = this.ciddocControl.valueChanges
				.startWith(null)
				.map(valT => valT ? this.filtroPrefijo(valT) : this.listaPrefijos.slice());


				if(opcional != undefined && opcional != ''){
					this.ciddoc.idOpcion = opcional+' - '+opcional;
				}

				//console.log(this.ciddoc);

			},
			error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los prefijos", "X");
			});
	}


	eventoConsulta1(opcional){
		
		this.listaPrefijos = new Array();
		this.ciddoc = new OpcionModel(" ", " ");


		this.listaPrefijos.push(new OpcionModel(opcional, opcional));

		this.snackBar.dismiss();

		this.ciddocOptions = this.ciddocControl.valueChanges
				.startWith(null)
				.map(valT => valT ? this.filtroPrefijo(valT) : this.listaPrefijos.slice());


				if(opcional != undefined && opcional != ''){
					this.ciddoc.idOpcion = opcional+' - '+opcional;
				}
	}



	eventoConsultaEscrituras1(opcional,prefijo,cnumcont,vdescripcion){
	this.consultarParticularidad(cnumcont,prefijo,opcional);
    console.log("PARAMETROS"+cnumcont+prefijo+opcional);
		//console.log("Michaellllllllll Villamil",opcional,' ===== ',prefijo);

		this.listaEscrituras = new Array();
		this.vidEscritura = new OpcionModel(" ", " ");

		this.listaEscrituras.push(new OpcionModel(opcional, vdescripcion));

		this.snackBar.dismiss();

		this.vidEscrituraOptions = this.vidEscrituraControl.valueChanges
		.startWith(null)
		.map(valT => valT ? this.filtroEscrituras(valT) : this.listaEscrituras.slice());

		if(opcional != undefined && opcional != ''){
			this.vidEscritura.idOpcion = opcional+' - '+vdescripcion;
		}
			this.traerListadoControl1(opcional,prefijo,cnumcont);
	}




    eventoConsultaEscrituras(opcional,prefijo){
		
        this.cnumcont.idOpcion = this.cnumcont.labelOpcion.substring(0,this.cnumcont.labelOpcion.indexOf('-')).trim();
        var ciddocTemp = this.ciddoc.idOpcion;
        ciddocTemp = ciddocTemp.substring(0,ciddocTemp.indexOf('-')).trim()

		

		this.listaEscrituras = new Array();
		this.vidEscritura = new OpcionModel(" ", " ");


		this._serviciosGenerales.get('listadoEscrituras', {cnumcont : this.cnumcont.idOpcion, ciddoc : ciddocTemp ,ntipoempresa : -1}).subscribe(
			
			result=>{
				for(let x in result){
                    //console.log("1");
                    this.listaEscrituras.push(new OpcionModel(result[x].vidEscritura.trim(), result[x].vdescripcion.trim()));
                }
				
				if(this.listaEscrituras.length == 0){
					this.openSnackBarEspecial("No se encontraron Escrituras para el contrato : "+this.cnumcont.idOpcion, "X");
					return;
				}
				else
					this.snackBar.dismiss();


                    
				this.vidEscrituraOptions = this.vidEscrituraControl.valueChanges
				.startWith(null)
				.map(valT => valT ? this.filtroEscrituras(valT) : this.listaEscrituras.slice());


				if(opcional != undefined && opcional != ''){
					this.vidEscritura.idOpcion = opcional+' - '+opcional;
				}

				//console.log(this.ciddoc);

			},
			error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los prefijos", "X");
			});
	}

    




	consultarPrefijos(){
//		console.log('Entró .... ', this.cnumcont);
this._serviciosGenerales.get('listadoPrefijos', {cnumcont:this.cnumcont.idOpcion}).subscribe(


	result=>{
		this.listaPrefijos = new Array();
		for(let x in result)
			this.listaPrefijos.push(new OpcionModel(result[x].cprefijo.trim(), result[x].cprefijo.trim()));

	},
	error=>{
		var errorMensaje = <any>error;
		console.log('Error al enviar la peticion ', errorMensaje);
		this.openSnackBarEspecial("Ocurrió un error al momento de cargar el prefijo", "X");
	}
	);
}

traerListadoControl1(opcional,prefijo,cnumcont){
	this.ocultar = false;
	this.mensaje = "Procesando Información ..";
	
	var ciddocTemp = prefijo;
    var vidEscrituraemp = opcional
		


	this.prefijoTresPuntos=ciddocTemp;
	this.contratoTresPuntos=cnumcont;
	this.escrituraTresPuntos=vidEscrituraemp;

		
		//console.log("=============> ",cnumcont,ciddocTemp,vidEscrituraemp);
		

		this._serviciosGenerales.get('nombreArchivoEscrituras', {cnumcont:cnumcont, ciddoc:ciddocTemp, vidEscritura:vidEscrituraemp}).subscribe(
			result => {

				//console.log("Michael =======> "+result.length);

				if (result.length == 0) {
					this.openSnackBarEspecial("No se encontro archivo de Escritura", "X");
					return;
				}
				for (let x of result) {

					this.nombreArchivo =  x.nombre

					this._serviciosGenerales.descargarArchivo('generarPdfInmobiliariaControlEscrituras/Escritura/CNUMCONT='+cnumcont+
					'&CPREFIJO='+ciddocTemp.trim()+
					'&VID_ESCRITURA='+vidEscrituraemp.trim()+
					'&NOMBRE_ARCHIVO='+this.nombreArchivo.trim()
					,null);
				
					setTimeout( () => { 
						this._serviciosGenerales.get('consultarListadoControl', {cnumcont:cnumcont, ciddoc:ciddocTemp, vidEscritura:vidEscrituraemp}).subscribe(
							result => {
								if (result.length == 0) {
									this.openSnackBarEspecial("Pdf de escritura no ha sido cargado, por favor validar.", "X");
									return;
								}

								this.mensaje = "";
								this.ocultar = true;
								var URLactual = window.location.href;
								var ruta=URLactual.split("ControlEscrituras");
								var dirección  =ruta[0]+"facturacion/"+this.nombreArchivo+".pdf";
								//var dirección  = "http://192.168.2.50:8091/facturacion/"+this.nombreArchivo+".pdf";
								this.safeSrc =  this.sanitizer.bypassSecurityTrustResourceUrl(dirección);
			
								this.dataDataBase = new EscriturasDatabase();
								for (let x of result) {
									this.dataDataBase.addEscritura(new ControlEscriturasModel(x.valor==1 ? true : false,x.nid, x.vdescripcion));
								}
								this.dataSource = new ExampleDataSource(this.dataDataBase);
							}, error => {
								this.openSnackBarEspecial("Ocurrió un error al momento de consultar la información", "X");
							}
						)
					}, 10000 );					
				}
			}, error => {
				this.openSnackBarEspecial("Ocurrió un error al momento de consultar la información", "X");
			}
		)


}




traerListadoControl(){
	this.ocultar = false;
	this.mensaje = "Procesando Información ..";
	


	var ciddocTemp = this.ciddoc.idOpcion;
        ciddocTemp = ciddocTemp.substring(0,ciddocTemp.indexOf('-')).trim()

		var vidEscrituraemp = this.vidEscritura.idOpcion;		

		let caracterTemp=''
        if(vidEscrituraemp.indexOf('-')==0){
            caracterTemp='-'
            vidEscrituraemp=vidEscrituraemp.slice(1)
        }
		
        vidEscrituraemp = vidEscrituraemp.substring(0,vidEscrituraemp.indexOf('-')).trim()
        vidEscrituraemp=caracterTemp.trim()+vidEscrituraemp
		
		//console.log("=============> ",this.cnumcont.idOpcion,this.cnumcont.idOpcion,vidEscrituraemp);
		

		this._serviciosGenerales.get('nombreArchivoEscrituras', {cnumcont:this.cnumcont.idOpcion, ciddoc:ciddocTemp, vidEscritura:vidEscrituraemp}).subscribe(
			result => {

				//console.log("Michael =======> "+result.length);

				if (result.length == 0) {
					this.openSnackBarEspecial("No se encontro archivo de Escritura", "X");
					return;
				}
				for (let x of result) {

					this.nombreArchivo =  x.nombre

					this._serviciosGenerales.descargarArchivo('generarPdfInmobiliariaControlEscrituras/Escritura/CNUMCONT='+this.cnumcont.idOpcion+
					'&CPREFIJO='+ciddocTemp.trim()+
					'&VID_ESCRITURA='+vidEscrituraemp.trim()+
					'&NOMBRE_ARCHIVO='+this.nombreArchivo.trim()
					,null);



				
					setTimeout( () => { 
						this._serviciosGenerales.get('consultarListadoControl', {cnumcont:this.cnumcont.idOpcion, ciddoc:ciddocTemp, vidEscritura:vidEscrituraemp}).subscribe(
							result => {
								if (result.length == 0) {
									this.openSnackBarEspecial("Pdf de escritura no ha sido cargado, por favor validar.", "X");
									return;
								}
								this.mensaje = "";
                                this.consultarParticularidad(this.cnumcont.idOpcion,ciddocTemp,vidEscrituraemp);
								this.ocultar = true;
								var URLactual = window.location.href;
                               // console.log( URLactual.replace("ControlEscrituras","facturacion/")+this.nombreArchivo+".pdf")
								//console.log("GGGGGGGGGGGGGGGGGG "+this._serviciosGenerales.path.replace("rest","")+URLactual);
								//var dirección  = URLactual.replace("ControlEscrituras","facturacion/")+this.nombreArchivo+".pdf";
								var dirección  = "http://192.168.2.50:8091/facturacion/"+this.nombreArchivo+".pdf";
								var ruta=URLactual.split("ControlEscrituras");
								var dirección  =ruta[0]+"facturacion/"+this.nombreArchivo+".pdf";
								this.safeSrc =  this.sanitizer.bypassSecurityTrustResourceUrl(dirección);
			
								this.dataDataBase = new EscriturasDatabase();
								for (let x of result) {
									this.dataDataBase.addEscritura(new ControlEscriturasModel(x.valor==1 ? true : false,x.nid, x.vdescripcion));
								}
								this.dataSource = new ExampleDataSource(this.dataDataBase);
							}, error => {
								this.openSnackBarEspecial("Ocurrió un error al momento de consultar la información", "X");
							}
						)
					}, 10000 );					
				}
			}, error => {
				this.openSnackBarEspecial("Ocurrió un error al momento de consultar la información", "X");
			}
		)


}

consultarParticularidad(cnumcont:string,ciddocTemp:string,vidEscrituraemp:string){

	this._serviciosGenerales.get('consultarParticularidad', {cnumcont:cnumcont, ciddoc:ciddocTemp, vidEscritura:vidEscrituraemp}).subscribe(
		result => {
		for(let x of result)
		this.vparticularidad = x.VPARTICULARIDAD;
		if(this.vparticularidad.length==0){
			this.vparticularidad ='No Aplica'
		}
		}, error => {
			this.openSnackBarEspecial("Ocurrió un error al momento de consultar la información", "X");
		}
	)	
console.log( "MUESTRA PARA CONSULTAR:"+cnumcont+ciddocTemp+vidEscrituraemp)
}


guardarControlEscrituras(){
	var cadena="";
	var suma=0;
	var contador=0;
	for (let x of this.dataDataBase.data) {
		contador++;
		if(x.activarChek){
			cadena = cadena +'NCHECK'+x.nid +":'"+1+"',"
		}
		else{
			cadena = cadena +'NCHECK'+x.nid +":'"+0+"',"
			suma = suma+1;
		}
	}

		if(suma==contador){
			this.openSnackBarEspecial("Debe seleccionar por lo menos un registro de la tabla para poder guardar.", "X");
			return;
		}



		var ntipoempresa = JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa 
		var usuario = JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().usuario).usuario
		
		
		var ciddocTemp = this.ciddoc.idOpcion;
		ciddocTemp = ciddocTemp.substring(0,ciddocTemp.indexOf('-')).trim()

		var vidEscrituraemp = this.vidEscritura.idOpcion;

		let caracterTemp=''
        if(vidEscrituraemp.indexOf('-')==0){
            caracterTemp='-'
            vidEscrituraemp=vidEscrituraemp.slice(1)
        }
		
        vidEscrituraemp = vidEscrituraemp.substring(0,vidEscrituraemp.indexOf('-')).trim()
        vidEscrituraemp=caracterTemp.trim()+vidEscrituraemp
		
		var contrato=  this.cnumcont.labelOpcion.substring(0,this.cnumcont.labelOpcion.indexOf('-')).trim();

		if(this.controlEscrituraTresPuntos){
			contrato = this.contratoTresPuntos;
			ciddocTemp = this.prefijoTresPuntos;
			vidEscrituraemp = this.escrituraTresPuntos;
		}
		
		var parametros = "{ procedimientoAntes: '-', procedimientoDespues: 'PROC_CONTROL_ESCRITURAS', tablaCargue: '-',tablaCargueArchivo:'',parametrosProcDespues:{CNUMCONT:"+'"'+contrato+'"'+",CPREFIJO:'"+ciddocTemp+"',VID_ESCRITURA:'"+vidEscrituraemp+"',"+cadena+"VUSUARIO:"+usuario+",NTIPOEMPRESA:'"+ntipoempresa+"',VPARTICULARIDAD:'"+this.vparticularidad+"'}}";		

		this._serviciosGenerales.post('cargueGenerico/'+parametros,'').subscribe(
			result=>{

				
				this.safeSrc =  this.sanitizer.bypassSecurityTrustResourceUrl("http://192.168.2.50:8091/facturacion/documento2.pdf");
				this.dataDataBase.clear();
				this.dataSource = new ExampleDataSource(this.dataDataBase);

				this.vidEscritura.idOpcion = '';
				
				this.openSnackBar("Se grabo control de escritura "+vidEscrituraemp+" de forma Exitosa", "X");
				//this._router.navigate(['/Escritura', contrato, ciddocTemp]);
				
			},error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de Guadar el Control de Escritura", "X");
			})


}

limpiarListado(){
	//console.log('adsfadsfafdadfasd');
	this.safeSrc =  this.sanitizer.bypassSecurityTrustResourceUrl("http://192.168.2.50:8091/facturacion/documento2.pdf");
	this.dataDataBase.clear();
	this.dataSource = new ExampleDataSource(this.dataDataBase);

}


openSnackBar(message: string, action: string)
{
	this.snackBar.open(message, action, {
		duration: 20000
	});
}

openSnackBarEspecial(message: string, action: string) {
	let snackBarRef =  this.snackBar.open(message, action);

	snackBarRef.onAction().subscribe(() => {

		this.ocultarSnackBar = false;
		this.mensajeSnackBar = "";
	});
	
	let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
	
	if (shand.length != 0) {
			for (let i=0;i<shand.length;i++){
			shand[i].style.backgroundColor = "rgb(255 204 214)";
			}
		}
}

}

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class EscriturasDatabase
{
	
	dataChange: BehaviorSubject<ControlEscriturasModel[]> = new BehaviorSubject<ControlEscriturasModel[]>([]);

	get data(): ControlEscriturasModel[]
	{
		return this.dataChange.value;
	}

	addEscritura(escritura:ControlEscriturasModel)
	{
		const copiedData = this.data.slice();
		copiedData.push(escritura);
		this.dataChange.next(copiedData);
	}

	clear(){
		this.dataChange = new BehaviorSubject<ControlEscriturasModel[]>([]);
	}

}



export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string
	{
		return this._filterChange.value;
	}

	set filter(filter: string)
	{
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: EscriturasDatabase)
	{
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<ControlEscriturasModel[]>
	{
		const displayDataChanges = [
		this._exampleDatabase.dataChange,
		this._filterChange
		];
		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: ControlEscriturasModel) => {
				let searchStr = (item.vdescripcion).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect()
	{
	}
}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ControlEscrituras/ControlEscrituras.component.ts